import {SET_IS_MOBILE} from "./availableActions";
import {SetIsMobileAction} from "../../interfaces/store/actions/mobile";

export const setIsMobile = (): SetIsMobileAction => ({
    type: SET_IS_MOBILE,
});
